import { jsxs as r, jsx as e } from "react/jsx-runtime";
import '../../../assets/index2.css';const d = "_card_irq8c_1", a = {
  card: d
};
function n(c) {
  return /* @__PURE__ */ r("article", { ...c, className: `${c.className || ""} ${a.card}`, children: [
    c.header ? /* @__PURE__ */ e("div", { className: a["card-header"], children: c.header }) : null,
    /* @__PURE__ */ e("div", { className: a["card-content"], children: c.children })
  ] });
}
export {
  n as Card
};
